export default __webpack_public_path__ + "static/media/data_configuration_hero.59c500d3.jpg";